import { render, staticRenderFns } from "./private.view.vue?vue&type=template&id=2bb34212&"
import script from "./private.view.ts?vue&type=script&lang=js&"
export * from "./private.view.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports